var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconAddPhotoUpload = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 6.688c.31 0 .563.253.563.562v11.243l-.176-.229-4.782-6.187a.846.846 0 0 0-1.336 0l-2.917 3.776-1.073-1.501A.838.838 0 0 0 9.344 14a.832.832 0 0 0-.686.355l-2.812 3.938-.159.218V7.25c0-.31.254-.563.563-.563h13.5zM6.25 5A2.252 2.252 0 0 0 4 7.25V18.5a2.252 2.252 0 0 0 2.25 2.25h13.5A2.252 2.252 0 0 0 22 18.5V7.25A2.252 2.252 0 0 0 19.75 5H6.25zm2.813 6.75a1.688 1.688 0 1 0 0-3.375 1.688 1.688 0 0 0 0 3.375z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAddPhotoUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-add-photo-upload.180158d7.svg";
export { ForwardRef as ReactComponent };